<template>
  <div class="ticket-main-section-sidebar flex-shrink-1 pt-4 px-3">
    <contact-sidebar v-if="sidebarSection === 'contacts'"></contact-sidebar>
    <axum-sidebar v-if="sidebarSection === 'axum'"></axum-sidebar>
    <tasks-sidebar v-if="sidebarSection === 'tasks'"></tasks-sidebar>
    <media-sidebar v-if="sidebarSection === 'media'"></media-sidebar>
    <related-tickets-sidebar v-if="sidebarSection === 'related-tickets'"></related-tickets-sidebar>
    <audit-sidebar v-if="sidebarSection == 'audit'"></audit-sidebar>
    <office-transfers-sidebar v-if="sidebarSection == 'office-transfers'"></office-transfers-sidebar>
    <expenses-sidebar v-if="sidebarSection == 'expenses'"></expenses-sidebar>
    <bookmarks-sidebar v-if="sidebarSection == 'bookmarks'"></bookmarks-sidebar>
    <incident-report-sidebar v-if="sidebarSection == 'incident-report'"></incident-report-sidebar>
  </div>
</template>

<script>
import Forms from "../../../../mixins/Forms";
import Tickets from "../../../../mixins/Tickets";
import AddContactModal from "./widgets/AddContactModal";
import Contact from "./widgets/Contact";
import ContactSidebar from "./TicketMainSectionSidebar/ContactSidebar";
import AxumSidebar from "./TicketMainSectionSidebar/AxumSidebar";
import TasksSidebar from "./TicketMainSectionSidebar/TasksSidebar";
import MediaSidebar from "./TicketMainSectionSidebar/MediaSidebar";
import axios from 'axios';
import {mapGetters, mapActions} from "vuex";
import AuditSidebar from "./TicketMainSectionSidebar/AuditSidebar";
import RelatedTicketsSidebar from "./TicketMainSectionSidebar/RelatedTicketsSidebar";
import OfficeTransfersSidebar from './TicketMainSectionSidebar/OfficeTransfersSidebar.vue';
import ExpensesSidebar from "./TicketMainSectionSidebar/ExpensesSidebar.vue";
import BookmarksSidebar from './TicketMainSectionSidebar/BookmarksSidebar.vue';
import IncidentReportSidebar from './TicketMainSectionSidebar/IncidentReportSidebar.vue';

export default {
  name: "TicketMainSectionSidebar",
  mixins: [Forms, Tickets],
  data() {
    return {}
  },
  created() {
  },
  components: {AuditSidebar, AddContactModal, Contact, ContactSidebar, AxumSidebar, TasksSidebar, MediaSidebar, RelatedTicketsSidebar, OfficeTransfersSidebar, ExpensesSidebar, BookmarksSidebar, IncidentReportSidebar},
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket',
      sidebarSection: 'sidebarSection'
    })
  },
  methods: {
    ...mapActions('ticketViewer', {
      reloadTicket: 'reloadTicket'
    }),

    openAddContactModal() {
      this.$bvModal.show('add-contact-modal');
    }
  }
}
</script>

<style lang="scss">
.ticket-main-section-sidebar {
  width: 250px;
  min-width: 250px;
  background: #ebeff3;
  box-shadow: inset 10px 0 10px -8px #ebeff3;

  .sidebar-inner {
    height: 100%;
    display: flex;
    flex-direction: column;

    .top-section {
      flex-grow: 1;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
